<div class="main-content py-4">
  <div class="container-fluid">
	<div class="row justify-content-center">
	  <div class="col-lg-10 col-xl-8">
		<div class="card shadow rounded-4 border-0">
		  <div class="card-header-{{color}} text-white d-flex align-items-center">
			<mat-icon class="me-2 cursor-pointer" (click)="back()">arrow_back</mat-icon>
			<h5 class="mb-0 fw-semibold">System Notice</h5>
		  </div>

		  <div class="card-body p-4 bg-light rounded-bottom">
			<form [formGroup]="noticeForm" (ngSubmit)="saveNotice()" class="mb-4">
			  <div class="mb-3">
				<mat-form-field appearance="outline" class="w-100">
				  <mat-label>Notice Message</mat-label>
				  <textarea matInput formControlName="message" rows="3"></textarea>
				</mat-form-field>
			  </div>

			  <div class="mb-3">
				<mat-form-field appearance="outline" class="w-100">
				  <mat-label>Priority</mat-label>
				  <input matInput type="number" formControlName="priority">
				</mat-form-field>
			  </div>

			  <div class="mb-3">
				<mat-form-field appearance="outline" class="w-100">
				  <mat-label>User Groups</mat-label>
				  <mat-select formControlName="groups" multiple appSelectAll>
					<mat-option *ngFor="let g of userGroups" [value]="g.user_group_id">
					  {{ g.name }}
					</mat-option>
				  </mat-select>
				</mat-form-field>
			  </div>

			  <div class="mb-3">
				<mat-form-field appearance="outline" class="w-100">
				  <mat-label>Locations</mat-label>
				  <mat-select formControlName="locations" multiple appSelectAll>
					<mat-option *ngFor="let loc of locations" [value]="loc.loccode">
					  {{ loc.locationname }}
					</mat-option>
				  </mat-select>
				</mat-form-field>
			  </div>

			  <div class="text-end">
				<button mat-raised-button color="primary" type="submit">
				  <mat-icon class="me-1">save</mat-icon>Save Notice
				</button>
			  </div>
			</form>

			<div *ngIf="notices.length">
			  <h5 class="fw-bold text-primary mb-3 d-flex align-items-center">
				<mat-icon class="me-2">campaign</mat-icon> Existing Notices
			  </h5>

			  <div class="table-responsive shadow rounded-3 overflow-hidden">
				<table class="table table-hover align-middle mb-0 border notice-table">
				  <thead class="table-light text-uppercase small text-secondary">
					<tr>
					  <th class="col-message">Message</th>
					  <th class="col-priority">Priority</th>
					  <th class="col-groups">Groups</th>
					  <th class="col-locations">Locations</th>
					  <th class="text-end col-actions">Actions</th>
					</tr>
				  </thead>
				  <tbody>
					<tr *ngFor="let n of notices">
					  <td class="text-wrap">{{ n.message }}</td>
					  <td><span class="badge bg-secondary">{{ n.priority || 0 }}</span></td>
					  <td>
						<ng-container *ngIf="!n.groups.length; else groupList">
						  <span class="text-muted fst-italic">All</span>
						</ng-container>
						<ng-template #groupList>
						  <span class="badge bg-info text-dark me-1" *ngFor="let g of n.groups">{{ g }}</span>
						</ng-template>
					  </td>
					  <td>
						<ng-container *ngIf="!n.locations.length; else locList">
						  <span class="text-muted fst-italic">All</span>
						</ng-container>
						<ng-template #locList>
						  <span class="badge bg-warning text-dark me-1" *ngFor="let l of n.locations">{{ l }}</span>
						</ng-template>
					  </td>
					  <td class="text-end">
						<button mat-icon-button color="primary" (click)="editNotice(n)" matTooltip="Edit">
						  <mat-icon>edit</mat-icon>
						</button>
						<button mat-icon-button color="warn" (click)="deleteNotice(n)" matTooltip="Delete">
						  <mat-icon>delete</mat-icon>
						</button>
					  </td>
					</tr>
				  </tbody>
				</table>
			  </div>
			</div>


		  </div>
		</div>
	  </div>
	</div>
  </div>
</div>
